import React, {Component} from 'react'

import {connect} from 'react-redux'

import {
  withRouter,
  Link
} from 'react-router-dom'

class RCMenu extends Component {
    render() {
      return (
        <ul className="pt-menu .modifier pt-elevation-1">
          <li>
            <Link className='pt-menu-item pt-popover-dismiss' to='/main/accounts'>Contas</Link>
          </li>
        </ul>
      )
    }
}

export default withRouter(connect()(RCMenu))


// WEBPACK FOOTER //
// ./src/scenes/menu/Menu.js